var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCalendar = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 21 23",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Icon_calendar",
  clipPath: "url(#clip0_3_1851)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Calendar"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M17.5216 22.8571H4.18831C2.35498 22.8571 0.85498 21.3143 0.85498 19.4286V5.71428C0.85498 3.82856 2.35498 2.28571 4.18831 2.28571H17.5216C19.355 2.28571 20.855 3.82856 20.855 5.71428V19.4286C20.855 21.3143 19.355 22.8571 17.5216 22.8571ZM4.18831 4.57142C3.5772 4.57142 3.0772 5.08571 3.0772 5.71428V19.4286C3.0772 20.0571 3.5772 20.5714 4.18831 20.5714H17.5216C18.1328 20.5714 18.6328 20.0571 18.6328 19.4286V5.71428C18.6328 5.08571 18.1328 4.57142 17.5216 4.57142H4.18831Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M6.41055 6.85714C5.79944 6.85714 5.29944 6.34286 5.29944 5.71429V1.14286C5.29944 0.514286 5.79944 0 6.41055 0C7.02166 0 7.52166 0.514286 7.52166 1.14286V5.71429C7.52166 6.34286 7.02166 6.85714 6.41055 6.85714Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_3",
  d: "M15.2995 6.85714C14.6884 6.85714 14.1884 6.34286 14.1884 5.71429V1.14286C14.1884 0.514286 14.6884 0 15.2995 0C15.9106 0 16.4106 0.514286 16.4106 1.14286V5.71429C16.4106 6.34286 15.9106 6.85714 15.2995 6.85714Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_4",
  d: "M6.41055 18.2857C5.79944 18.2857 5.29944 17.7714 5.29944 17.1429V16C5.29944 15.3714 5.79944 14.8571 6.41055 14.8571C7.02166 14.8571 7.52166 15.3714 7.52166 16V17.1429C7.52166 17.7714 7.02166 18.2857 6.41055 18.2857Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_5",
  d: "M10.855 18.2857C10.2439 18.2857 9.7439 17.7714 9.7439 17.1429V16C9.7439 15.3714 10.2439 14.8571 10.855 14.8571C11.4661 14.8571 11.9661 15.3714 11.9661 16V17.1429C11.9661 17.7714 11.4661 18.2857 10.855 18.2857Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_6",
  d: "M15.2995 18.2857C14.6884 18.2857 14.1884 17.7714 14.1884 17.1429V16C14.1884 15.3714 14.6884 14.8571 15.2995 14.8571C15.9106 14.8571 16.4106 15.3714 16.4106 16V17.1429C16.4106 17.7714 15.9106 18.2857 15.2995 18.2857Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_7",
  d: "M6.41055 13.7143C5.79944 13.7143 5.29944 13.2 5.29944 12.5714V11.4286C5.29944 10.8 5.79944 10.2857 6.41055 10.2857C7.02166 10.2857 7.52166 10.8 7.52166 11.4286V12.5714C7.52166 13.2 7.02166 13.7143 6.41055 13.7143Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_8",
  d: "M10.855 13.7143C10.2439 13.7143 9.7439 13.2 9.7439 12.5714V11.4286C9.7439 10.8 10.2439 10.2857 10.855 10.2857C11.4661 10.2857 11.9661 10.8 11.9661 11.4286V12.5714C11.9661 13.2 11.4661 13.7143 10.855 13.7143Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_9",
  d: "M15.2995 13.7143C14.6884 13.7143 14.1884 13.2 14.1884 12.5714V11.4286C14.1884 10.8 14.6884 10.2857 15.2995 10.2857C15.9106 10.2857 16.4106 10.8 16.4106 11.4286V12.5714C16.4106 13.2 15.9106 13.7143 15.2995 13.7143Z"
}))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_3_1851"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 22.8571,
  fill: "white",
  transform: "translate(0.85498)"
})))));
export default SvgIconCalendar;